import { IDataTableHeader } from '@typings/components';

export const VIN_DECODE_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'VIN Number',  align: 'left' },
  { label: 'Date / Time', align: 'left' },
  { label: 'Result',      align: 'center' },
  { label: 'Institution', align: 'left' },
  { label: 'Type',        align: 'center' },
  { label: 'YMM',         align: 'left' },
];

export const SERVICE_STATS_HEADERS: IDataTableHeader[] = [{
  label: '',
}, {
  label   : 'SRS',
  align   : 'center',
  colSpan : 2,
}, {
  label : 'VRM',
  align : 'center',
}, {
  label   : 'Express Recoveries',
  align   : 'center',
  colSpan : 2,
}, {
  label   : 'CUA',
  align   : 'center',
  colSpan : 2,
}, {
  label : 'Reindeer Logistics',
  align : 'center',
}];

export const SERVICE_STATS_SUBHEADERS: IDataTableHeader[] = [
  { label: 'Period', align: 'center' },

  // SRS
  { label: 'Repos',        align: 'center' },
  { label: 'Auction Sale', align: 'center' },

  // VRM
  { label: 'Repos', align: 'center' },

  // Express Recoveries
  { label: 'Vehicles', align: 'center' },
  { label: 'Products', align: 'center' },

  // CUA
  { label: 'Postings', align: 'center' },
  { label: 'Sales',    align: 'center' },

  // Reindeer Logistics
  { label: 'Quotes', align: 'center' },
];

export const MONTH_INNER_STATS_HEADERS: IDataTableHeader[] = [{
  label: '',
}, {
  label   : 'VIN Decode Analysis',
  align   : 'center',
  colSpan : 2,
}, {
  label   : 'Ads',
  align   : 'center',
  colSpan : 2,
}, {
  label : 'Invoices',
  align : 'center',
}, {
  label : 'Auctions',
  align : 'center',
}];

export const MONTH_INNER_STATS_SUBHEADERS: IDataTableHeader[] = [
  { label: 'Period', align: 'center' },

  // VIN Decode Analysis
  { label: 'Success', align: 'center' },
  { label: 'Failed',  align: 'center' },

  // Ads
  { label: 'Total',   align: 'center' },
  { label: 'Running', align: 'center' },

  // Invoices
  { label: 'Amount', align: 'center' },

  // Auctions
  { label: 'Total Bids', align: 'center' },
];

export const TOTAL_INNER_STATS_HEADERS: IDataTableHeader[] = [{
  label   : 'VIN Decode Analysis',
  align   : 'center',
  colSpan : 2,
}, {
  label   : 'Ads',
  align   : 'center',
  colSpan : 2,
}, {
  label   : 'Invoices',
  align   : 'center',
  colSpan : 3,
}, {
  label   : 'Auctions',
  align   : 'center',
  colSpan : 4,
}];

export const TOTAL_INNER_STATS_SUBHEADERS: IDataTableHeader[] = [
  // VIN Decode Analysis
  { label: 'Success', align: 'center' },
  { label: 'Failed',  align: 'center' },

  // Ads
  { label: 'Total',   align: 'center' },
  { label: 'Running', align: 'center' },

  // Invoices
  { label: 'Current Due',            align: 'center' },
  { label: 'Past Due',               align: 'center' },
  { label: 'Current Month Estimate', align: 'center' },

  // Auctions
  { label: 'Total Bids',           align: 'center' },
  { label: 'Active Auctions',      align: 'center' },
  { label: 'Active Users',         align: 'center' },
  { label: 'Active Auction Views', align: 'center' },
];
